import {useEffect, useRef} from 'react'
import dayjs from 'dayjs'
import {Confirm, useOpenModal} from '@/components/Modal/index.mjs'
import IndexedDb from '@/script/IndexedDb.mjs'
import {createPlugin} from '@/components/MindMap/index.mjs'

const EXPIRES_AFTER = 604800000 // 1 week

export default () => {
    const openModal = useOpenModal()
    const refDb = useRef()
    const refShouldSave = useRef(false)

    useEffect(
        () => {
            ;(async () => {
                const db = new IndexedDb('SWAP', 1)
                refDb.current = db

                db.open(db => {
                    const store = db.createObjectStore('swaps', {keyPath: 'id'})
                    store.createIndex('lastModified', 'lastModified')
                })

                await db.transaction('swaps', 'readwrite').do(async t => {
                    const store = t.objectStore('swaps')
                    const expireAt = Date.now() - EXPIRES_AFTER
                    const range = IDBKeyRange.upperBound(expireAt)

                    for await (
                        const c of
                        store.openCursorOnIndex('lastModified', range)
                    ) {
                        c.delete()
                    }
                })
            })()
        },

        []
    )

    const watchers = {
        async load() {
            if (! this.permission.has('write')) {
                return
            }

            const {id, uptTime} = this.data

            if (! id) {
                return
            }

            const swap = await refDb.current.get('swaps', id)

            if (! swap) {
                return
            }

            const lastModified = dayjs(uptTime).valueOf()

            if (lastModified < swap.lastModified) {
                const isConfirmed = await openModal(
                    <Confirm>
                        发现临时地图数据，这可能是上次编辑地图后未保存就退出编辑或意外关闭，是否用临时数据进行恢复？
                    </Confirm>
                )

                if (isConfirmed) {
                    const {data, root} = swap

                    await this.execute(async () => {
                        this.data = data
                        const _n = this.nodeProxy(this.root)
                        await _n.replace(root)
                    })
                }
            }
            else {
                await refDb.current.delete('swaps', id)
            }
        },

        //meta_change() {
            //refShouldSave.current = true
        //},

        model_change(modelChanges) {
            if (! this.permission.has('write')) {
                return
            }

            refShouldSave.current = modelChanges.keys().some(
                node => {
                    const _n = this.nodeProxy(node)
                    return _n.canWriteData() || _n.canWriteTree()
                }
            )
        },

        save() {
            refDb.current.delete('swaps', this.data.id)
        },

        async task_execute() {
            if (! refShouldSave.current) {
                return
            }

            refShouldSave.current = false
            const {data, root} = this

            if (! data.id) {
                return
            }

            const _n = this.nodeProxy(root)

            const swap = {
                data,
                id: data.id,
                lastModified: Date.now(),
                root: _n.exportTree({compact: true}),
            }

            try {
                await refDb.current.put('swaps', swap)
            }
            catch (err) {
                refShouldSave.current = true
                throw err
            }
        },
    }

    //return createPlugin('swap', {watchers})
    return {}
}
